//const baseAddress = "http://127.0.0.1:5000/";
const baseAddress = "https://ripplesimulatorapi.azurewebsites.net/";
export { baseAddress };
